import React, { PropsWithChildren } from 'react';
import { Table as TableContainer, TableProps as TablePropsContainer } from 'react-bootstrap';
import { ECTableColumns, TableDataSource } from 'Types/Common/Table';
import MessageError from 'Components/Common/MessageError';

interface TableProps extends TablePropsContainer {
  tableKey: string;
  columns: ECTableColumns[];
  dataSource: TableDataSource[] | undefined;
  errors?: { message: string }[];
  onClickError?: () => void;
}

function ECTable({
  tableKey,
  columns,
  dataSource,
  errors = [],
  onClickError,
  ...props
}: PropsWithChildren<TableProps>): JSX.Element {
  return (
    <TableContainer {...props} key={tableKey}>
      <thead>
        <tr>
          {columns.map(({ title, key, headerClass }, index) => (
            <th key={key} className={`${index === 0 ? 'text-center' : ''} ${headerClass}`}>
              {title}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {dataSource?.map((item, index) => (
          <>
            <tr key={index}>
              {columns.map((col, k) => (
                <td
                  key={`${col.key}-${index}`}
                  className={`align-middle ${k === 0 ? 'text-center' : ''} ${
                    k === columns.length - 1 ? 'text-end' : ''
                  } ${col.rowClass}`}
                >
                  {col.render ? (
                    col.dataIndex === 'index' ? (
                      index + 1
                    ) : (
                      col.render(item[col.dataIndex], item, index)
                    )
                  ) : (
                    <p>{item[col.dataIndex]}</p>
                  )}
                </td>
              ))}
            </tr>
            {errors[index] && (
              <tr onClick={onClickError}>
                <MessageError message={errors[index].message} classWrapper="ms-2 w-max-content" />
              </tr>
            )}
          </>
        ))}
      </tbody>
    </TableContainer>
  );
}
export default ECTable;
